import request from './base/api';

export function registerMember(
  { branch_id, phone, birthday, gender, email },
  cb,
  errCb
) {
  const config = {
    data: {
      branch_id,
      phone,
      birthday,
      gender,
      email
    }
  };

  return request({
    url: 'member/register',
    method: 'post',
    cb,
    errCb,
    config
  });
}

export default {
  registerMember
};
